<template>
  <div id="error">
    <div class="d-flex flex-column justify-content-center align-items-center py-5 my-3">
        <h3>{{message}}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error",
  props:['message']
}
</script>
<style scoped lang="less">
    h3{
      color:#fff!important;
    }
</style>